import { Accordion } from '../../../../../components/general/accordion';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { Table } from '../../../../../components/general/table';
import { usePqrAttachment } from './hook';
import { PqrAttachmentProps } from './props';

export const PqrAttachment = (props: PqrAttachmentProps) => {
    const { columns, rows } = usePqrAttachment(props);

    return (
        <Accordion
            title="ARCHIVOS ADJUNTOS"
            icon={<AttachmentIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={rows.length}
                pageSizeOptions={[10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
